import { FavouriteConnections } from 'app/types-shared';
import { ConnectionsOperatorTypes } from 'app/components/filters/types';

export const mapConnections = (connections: FavouriteConnections[] = []) => {
  const mapping = (value: any) => {
    return value ? value.map(connection => {
      return {
        value: connection.connected.v,
        description: connection.connected.d
      };
    }) : [];
  };

  return {
    include: mapping(connections.filter(c => c.operator.v === ConnectionsOperatorTypes.include)),
    exclude: mapping(connections.filter(c => c.operator.v === ConnectionsOperatorTypes.exclude))
  };
};
